
import { Component, Vue } from 'vue-property-decorator'
import NotificationService from '@/services/NotificationService'

@Component({
  name: 'ServiceWorkerUpdatePopup'
})
export default class extends Vue {
  private refreshing = false
  private waitingToReload = false
  private registration: ServiceWorkerRegistration | null = null

  created() {
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })

    if ('serviceWorker' in navigator && navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!this.waitingToReload) return
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()
      })
    }
  }

  render() {
    // Avoid warning for missing template
  }

  private async showRefreshUI(e: Event) {
    this.registration = (e as CustomEvent).detail

    const refresh = await NotificationService.pwaUpdate()
    if (refresh) {
      e.preventDefault()
      this.refreshApp()
    }
  }

  private refreshApp() {
    if (!this.registration || !this.registration.waiting) return
    this.waitingToReload = true
    this.registration.waiting.postMessage('skipWaiting')
  }
}
